import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app" }

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import { listArt } from '@/common/list'

export default /*@__PURE__*/_defineComponent({
  __name: 'ArtPage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      value: _unref(listArt),
      class: "auction-table",
      "responsive-layout": "scroll",
      paginator: true,
      rows: 100,
      "striped-rows": true,
      "sort-mode": 'single'
    }, {
      header: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("h2", null, "Список артефактов", -1)
      ])),
      default: _withCtx(() => [
        _createVNode(_unref(Column), {
          field: "name",
          header: "Название",
          sortable: ""
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_router_link, {
              to: { name: 'art', params: { id: data.id } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.name), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})